jQuery(document).ready(function($) {
	$(window).on('scroll', function() {
		var scrollTop = $(this).scrollTop();

		// Sticky after 1px
		if (scrollTop > 1) {  
			$('.s-header').addClass('sticky');
		} else {
			$('.s-header').removeClass('sticky');
		}

		// Small after 200px
		if (scrollTop > 200) {
			$('.s-header').addClass('small');
		} else {
			$('.s-header').removeClass('small');
		}
	});
});



jQuery(function ($) {
  $('.markets-slider').each(function () {
	var $slider = $(this);
	if ($slider.hasClass('is-initialized')) return;

	var $section = $slider.closest('.markets-slider-area');
	var $arrows  = $section.find('.markets-arrows');
	var $prev    = $arrows.find('.markets-prev');
	var $next    = $arrows.find('.markets-next');

	$slider.on('init', function () {
	  $slider.addClass('is-initialized');
	  $prev.on('click', function(){ $slider.slick('slickPrev'); });
	  $next.on('click', function(){ $slider.slick('slickNext'); });
	});

	$slider.slick({
	  slidesToShow: 5,
	  slidesToScroll: 1,
	  infinite: false,
	  dots: false,
	  arrows: false,
	  adaptiveHeight: false,
	  accessibility: true,
	  responsive: [
		{ breakpoint: 1200, settings: { slidesToShow: 2 } },
		{ breakpoint: 992,  settings: { slidesToShow: 2 } },
		{ breakpoint: 768,  settings: { slidesToShow: 1 } }
	  ]
	});

	$arrows.on('keydown', function (e) {
	  if (e.key === 'ArrowLeft')  { e.preventDefault(); $slider.slick('slickPrev'); }
	  if (e.key === 'ArrowRight') { e.preventDefault(); $slider.slick('slickNext'); }
	});
  });
});



jQuery(document).ready(function($) {
/* Embedded Videos */
var $embedded_videos = $('.gen-cont iframe');
$embedded_videos.each(function(e) {
	var $this = $(this),
		attr = $this.attr('src');
	console.log(attr);
	if ( attr.indexOf( 'youtu' ) !== -1 || attr.indexOf( 'vimeo' ) !== -1 ) {
		$this.wrap('<div class="video-wrapper"></div>');
	}
});
});